import { useHistory, useLocation } from 'react-router-dom';

function useNavigationType() {
  const history = useHistory();
  const location = useLocation();

  const isDirectNavigation = history.action === 'POP' && !location.state;
  
  return {
    navType: history.action, // 'PUSH', 'REPLACE', 'POP'
    isDirectNavigation, // true, if user enter URL manually
    location, // can use for additional analysis
  };
}

export default useNavigationType;
